export default __webpack_public_path__ + "static/media/img-40.a3bb9fd9.jpg";